module.exports = "/images/hero-001@2x.png?9f7aa8562d241923d6a1a20bd0e0d675";